import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { CloseIcon, SearchIcon, TextField } from "@flat-ui";
import { InputAdornment } from "@mui-wrapper";
// TODO: Refactor to cover MarkupAssigneeEditable search box: https://faro01.atlassian.net/browse/ST-2032
/**
 * A small component that shows a search box
 * This is copied from MarkupAssigneeEditable component with some changes.
 */
export function FilterChipSearch(t0) {
  const $ = _c(15);
  const {
    searchText,
    setSearchText,
    onEscape
  } = t0;
  let t1;
  if ($[0] !== onEscape) {
    t1 = event => {
      if (event.key === "Escape") {
        onEscape?.();
      }
      event.stopPropagation();
    };
    $[0] = onEscape;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      "aria-label": "Search",
      autoComplete: "off"
    };
    t3 = {
      px: 1
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== searchText.length || $[5] !== setSearchText) {
    t4 = searchText.length > 0 && <SphereIconButton component={CloseIcon} onClick={() => setSearchText("")} iconSize="20px" buttonSize="26px" iconButtonProps={{
      sx: {
        mr: "4px"
      }
    }} />;
    $[4] = searchText.length;
    $[5] = setSearchText;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SearchIcon sx={{
      width: "18px",
      height: "18px"
    }} />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <InputAdornment position="end">{t4}{t5}</InputAdornment>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== searchText || $[11] !== setSearchText || $[12] !== t1 || $[13] !== t6) {
    t7 = <TextField fullWidth={true} variant="standard" placeholder="Search" autoFocus={true} text={searchText} onTextChanged={setSearchText} onKeyDown={t1} inputProps={t2} controlStyle={t3} endAdornment={t6} />;
    $[10] = searchText;
    $[11] = setSearchText;
    $[12] = t1;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}